/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'uuid': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<g _fill="#C4FFF9" fill-rule="nonzero"><path pid="0" d="M45.059 90.441h17.883V72.558H45.059v17.883zm2-15.871h13.883v13.871H47.059V74.57zM69.059 85.441h38.879v2H69.059zM69.059 75.559h22.879v2H69.059z"/><path pid="1" d="M82 43.5H68v9H35v54h80v-54H82v-9zm-12 2h10v15H70v-15zm43 9v50H37v-50h31v8h14v-8h31z"/></g>'
  }
})
